import { useLocation } from 'react-router-dom';
import { ReCaptchaProvider } from '@/providers/recaptcha';
import { BasicLayout } from '../../layouts/BasicLayout';
import SignUp from '../../containers/SignUp';
import SignUpCoFounder from '../../containers/SignUpCoFounder';

const SignUpPage = () => {
  const location = useLocation();
  return (
    <BasicLayout>
      <div className="container">
        <ReCaptchaProvider>
          {location.pathname.includes('co-founder') ? <SignUpCoFounder /> : <SignUp />}
        </ReCaptchaProvider>
      </div>
    </BasicLayout>
  );
};

export default SignUpPage;
